import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BalanceSheetSourceEnum } from '@zaoblako/shared/modules/catalog/enums/balance-sheet-source.enum';
import { BalanceSheetSourceEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/balance-sheet-source-enum.i18n';

@Pipe({
  standalone: true,
  name: 'balanceSheetSourceName'
})
export class BalanceSheetSourceNamePipe implements PipeTransform {
  public transform(type: BalanceSheetSourceEnum): string {
    return BalanceSheetSourceEnumI18n?.[I18nLocalesEnum.RU_RU]?.[type] || '';
  }
}
